import type { LoadSubImagesRegistry } from '../../types/templates/load-sub-images';
import { loadSubImages as espnHerosLoadSubImages } from './espn/espn-heros/helpers/load-sub-images';

export const disneyLoadSubImagesRegistry: LoadSubImagesRegistry = {
  'espn-heros-players': (item, group, formData) => espnHerosLoadSubImages(item, group, formData.league as string)
};
